import { render, staticRenderFns } from "./VInput.vue?vue&type=template&id=24734012&scoped=true&lang=pug&"
import script from "./VInput.vue?vue&type=script&lang=js&"
export * from "./VInput.vue?vue&type=script&lang=js&"
import style0 from "./VInput.vue?vue&type=style&index=0&id=24734012&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24734012",
  null
  
)

export default component.exports